import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { RefreshCw, CheckCircle2 } from 'lucide-react';

interface LastSyncCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function LastSyncCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: LastSyncCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Last Sync
            </CardTitle>
            <RefreshCw className="h-4 w-4 text-muted-foreground" />
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="h-4 w-4 text-green-600" />
              <span className="text-sm">2 minutes ago</span>
            </div>
            <div className="text-xs text-muted-foreground">
              All data sources synced successfully
            </div>
            <Badge className="bg-green-100 text-green-800 text-[10px]">
              Up to date
            </Badge>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
